module.exports = __webpack_public_path__ + "static/img/lower_normal.d646d3f.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/lower_normal.svg
// module id = 541
// module chunks = 0